
import { defineStore } from "pinia";

export const useStringStore = defineStore('stringStore', {
  state : () => ({

'universal_button_start_game' : 'Start Game',
'universal_make_move_string' : 'Make Move',
'blind_history_title' : 'Game History',
'excel_export_blindfold_puzzles_title_string' : 'Blindfold Puzzle Export to PGN',
'excel_export_blindfold_puzzles_descrption_string' : 'All blindfold puzzles you have done will be export to a PGN. A download link will be emailed to you.',
'excel_export_blindfold_game_title_string' : 'Blindfold Game Export to PGN',
'excel_export_blindfold_game_description_string' : 'All blindfold games you have done will be export to a PGN. A download link will be emailed to you.',
'blind_menu_play' : 'Blindfold Play',
'blind_menu_export' : 'Game Export',
'blind_play_button_new_game' : 'New Game',
'blind_play_button_end_game' : 'End Game',
'blind_play_button_take_back' : 'Take Back',
'blind_play_move_taken_back_string' : 'Move Taken Back',
'blind_game_please_start_game_string' : 'Please Start Game',
'blind_play_end_game_string' : 'Do you want to end the game?',
'blind_play_please_confirm_string' : 'Please Confirm',
'blind_play_options_title' : 'Blindfold Options',
'blind_play_options_difficulty_string' : 'Blindfold Level',
'blind_play_options_takeback_string' : 'Takeback Time Delay',
'blind_play_options_color_string' : 'Color You Play',
'blind_play_options_skill_string' : '"Engine Strength (Skill)"',
'blind_play_options_engine_string' : 'Engine for Opponent Moves',
'blindfold_non_subscriber_limit' : 'The non-subscriber limit of 10 moves has been reached.',
'blindfold_puzzle_subscriber_message' : 'Blindfold puzzles which enable you practice your visualization skills across the entire puzzle collection are a subscriber benefit.',
'blindfold_result_string' : 'Result',
'server_blindfold_regular' : 'Regular Pieces',
'server_blindfold_one_color' : 'One Color Pieces',
'server_blindfold_two_disks' : 'Two Color Disks',
'server_blindfold_one_disk' : 'One Color Disk',
'server_blindfold_empty_board' : 'Empty Board',
'server_blindfold_regular_short' : 'Not Blind',
'server_blindfold_one_color_short' : 'Shared Pieces',
'server_blindfold_two_disks_short' : 'Two Disks',
'server_blindfold_one_disk_short' : 'Shared Disk',
'server_blindfold_komodo' : 'Komodo (Best To Start)',
'server_blindfold_stockfish' : 'Stockfish',
'server_blindfold_skill' : 'Skill',
'server_blindfold_maximum' : 'Maximum',
'server_blindfold_equivalent' : 'Equiv.',
'server_blindfold_using' : 'Using',
'server_blindfold_engine' : 'Engine',
'server_blindfold_takeback_time' : 'Takeback Time',
'server_blindfold_takeback' : 'Takeback',
'server_blindfold_play_white' : 'Play as White',
'server_blindfold_play_black' : 'Play as Black',
'server_blindfold_second' : 'sec.',
'server_blindfold_seconds' : 'secs.',
'server_blindfold_white_ahead' : 'White by',
'server_blindfold_black_ahead' : 'Black by',
'blind_play_options_reveal_string' : 'Reveal Board',
'server_never_reveal' : 'Never Reveal Board',
'server_reveal_every' : 'Reveal Every',
'ion_error_top' : 'Chessvis had the following error while communicating with its on-line server',
'ion_error_bottom' : 'If this persists and is not associated with your connectivity, please let us know at: support@chessvis.com',
'ion_error_bottom_reference' : 'And Reference',
'suggest_subscribe_for_month' : 'You can subscribe for as short as a month.',
'main_menu_not_logged_in_warning' : 'You are not logged in as a registered user.',
'main_menu_not_logged_warning_line2' : 'Chessvis will not remember which puzzles you have attempted or your results.',
'main_menu_not_logged_warning_line3' : 'Registering is free.',
'main_menu_not_logged_opening_warning' : 'Chessvis will not remember the repertoire information.',
'main_menu_user_not_subscriber_warning' : 'NOTE: Non-subscribers can access all parts of the Opening section but are limited to a depth of 5 moves.',
'main_menu_user_not_subscriber_blindfold_warning_line1' : 'NOTE: Non-subscribers can play the first 10 moves in blindfold games. Blindfold puzzles require a subscription.',
'main_menu_user_not_subscriber_blindfold_warning_line2' : 'I suggest watching the video (in the library).',
'no_email_for_download' : 'You don\'t have an email address on the database but the file can be downloaded from here:',
'report_menu_subscriber_heading' : 'Subscriber Graphs',
'report_menu_data_to_excel' : 'My data to Excel',
'line_graph_title' : 'Rating Graph',
'success_graph_title' : 'Success Graph',
'universal_visualize_portrait_line1' : 'Visual',
'universal_button_puzzle_type_line1' : 'Puzzle',
'universal_button_puzzle_type_line2' : 'Type',
'universal_button_time_period_line2' : 'Period',
'universal_button_display_order_line1' : 'Display',
'universal_button_display_order_line2' : 'Order',
'excel_export_title' : 'Excel Output',
'excel_export_description_string' : 'All activity you have done on Chessvis will be written to a multiple spreadsheet workbook. A download link will be emailed to you.',
'excel_export_button_send' : 'Yes, send it',
'excel_export_button_skip' : 'Skip it',
'excel_export_puzzle_title_string' : 'Puzzle Export to PGN',
'excel_export_puzzle_description_string' : 'All puzzles you have done will be export to a PGN. A download link will be emailed to you.',
'graph_not_subscriber_message' : 'The \'Success Graphs\' give insight into the types of puzzles you success or have problems with. That, getting an Excel workbook of all Chessvis activity and the \'Speed Puzzle Rating Graph\' is reserved for Subscribers.',
'server_graph_time_hour' : 'Last hour',
'server_graph_time_24hours' : 'Last 24 hours',
'server_graph_time_7days' : 'Last 7 days',
'server_graph_time_30days' : 'Last 30 days',
'server_graph_time_6months' : 'Last 6 months',
'server_graph_seconds' : 'Secs',
'server_graph_visualize_1ply' : '1 Half move (1 ply)',
'server_graph_visualize_1ply_title' : '1 ply',
'server_graph_lifetime' : 'Lifetime',
'server_graph_title_puzzles' : 'Puzzles',
'server_graph_visualized_string' : 'Visualized',
'server_graph_moves_visualized_string' : 'Moves Visualized',
'server_graph_time_title' : 'Select Time Period',
'server_graph_type_title' : 'Select Puzzle Type(s)',
'server_graph_speed_title' : 'For Timed Puzzles, Select Speed(s)',
'server_graph_visualize_title' : 'For Visualized Puzzles, Select # of Moves',
'server_graph_success_for' : 'for',
'server_graph_category_title' : 'Select What to Graph',
'server_graph_rating_segments' : 'Rating Segments',
'server_graph_category_alpha' : 'Category Alphabetic (English Order)',
'server_graph_category_success' : 'Category Most Success',
'server_graph_category_most' : 'Category Most Puzzles',
'server_graph_category_option' : 'Category In Option Order',
'download_link_sent_to' : 'The download link has been sent to ->',
'download_can_be_viewed_here' : '\"    It can also be downloaded from here: \"',
'solveit_success_chart' : 'Solve-it Success Barchart',
'solveit_comparison_chart' : 'Solve-it Compare Barchart',
'success_chart_by_category' : 'Success by Category Barchart',
'success_chart_by_puzzle_type' : 'Success by Puzzle Type Barchart',
'compare_chart_by_category' : 'Category Compare Barchart',
'compare_chart_by_puzzle_type' : 'Puzzle Type Compare Barchart',
'server_graph_user_community' : 'User Community',
'server_graph_prior_period' : 'Prior Time Period',
'server_graph_all_my_data' : 'All Prior',
'success_options_title' : 'Success Barchart Options',
'success_options_sort_string' : 'Sort Order',
'success_options_cross_reference_string' : 'Category Cross Reference?',
'success_options_compare_string' : 'Compare Against',
'success_list_button' : 'List',
'success_graph_button' : 'Graph',
'guard_knight_string' : 'Knight Guards',
'guard_queen_string' : 'Queen Guards',
'guard_bishop_string' : 'Bishop Guards',
'guard_rook_string' : 'Rook Guards',
'guard_title_landscape' : 'Who\'s Guarding Whom',
'guard_title_portrait' : 'Who\'s Guarding',
'guard_button_check' : 'Check Guarding',
'guard_find_initial' : 'Find Initial Guardings',
'guard_report_errors' : 'Errors',
'guard_extracting_message' : 'Retrieving Guarding',
'guard_check' : 'Check Guardings',
'guard_new_start' : 'New Start',
'guard_show_next_move' : 'Show Next Move',
'universal_knight_string' : 'Knight',
'universal_bishop_string' : 'Bishop',
'universal_rook_string' : 'Rook',
'universal_queen_string' : 'Queen',
'ios_please_note' : 'Please Note',
'ios_universal_back' : 'Back',
'ios_universal_chessvis' : 'Chessvis',
'ios_universal_ok' : 'OK',
'ios_universal_free' : 'Free',
'ios_thanks_subscribing_renewing' : 'Thank you for subscribing or renewing!',
'ios_for_subscribers' : 'For Subscribers',
'ios_need_offline_sync' : 'Need Off-line Sync',
'ios_static_evaluation' : 'Evaluation Test',
'ios_explore_reveal' : 'Explore or Reveal',
'ios_animating_solution' : 'Animating Solution',
'ios_flip_board' : 'Flip Board',
'ios_add_comment_description' : 'Add comment for current board position',
'ios_practice_title' : 'Practice',
'ios_retrieving_page' : 'Retrieving Page',
'ios_retrieving_video' : 'Retrieving Video',
'ios_enter_repertoire_name' : 'Please enter the repertoire name',
'ios_select_repertoire_color' : 'Repertoire are played either as White or Black',
'ios_select_repertoire_color_heading' : 'Select a Color',
'ios_edit_repertoire_title_delete' : 'Delete Repertoire',
'ios_edit_repertoire_title_add' : 'Add Repertoire',
'ios_edit_repertoire_title_copy' : 'Copy Repertoire',
'ios_import_hint' : 'email name',
'ios_import_invalid_name_heading' : 'Invalid Name',
'ios_import_name_change_heading' : 'Name Changed',
'ios_import_name_error_heading' : 'Name Error',
'ios_library_error_heading' : 'Library Error',
'ios_library_copy_heading' : 'Repertoire Copied',
'ios_library_contribution_heading' : 'Repertoire Contribution',
'ios_login_welcome_back' : 'Welcome Back',
'ios_subscribe_login' : 'You must be logged in before becoming a subscriber. Subscriptions are associated with your email address which enables you to move between devices.',
'ios_subscribe_button' : 'Yes! I want to Subscribe! (Or Restore)',
'ios_subscribe_title' : 'Subscribe',
'ios_subscribe_text' : 'Chessvis subscriptions unlock Openings beyond 5 moves, add timed puzzles, graphics & more',
'ios_restore_subscription' : 'Restore Subscription',
'ios_tos_button' : 'Terms of Service & Privacy Policy',
'ios_thank_you' : 'Thank You!',
'ios_subscription_problem' : 'There\'s a Problem',
'ios_subscription_parent_controls' : 'The the device is not allowed to make purchases. Please check the settings to see if there Parental Controls or limitations.',
'ios_subscription_failed' : 'The payment transaction failed.',
'ios_non_subscriber_title' : 'Non-Subscriber limit',
'ios_support_title' : 'Support',
'ios_blindfold_puzzle_title' : 'Blindfold Puzzles',
'ios_server_error' : 'Error report from Chessvis server',
'ios_json_error' : 'Error in the json data returned from server',
'ios_server_no_response' : 'No response from chessvis server',
'ios_blindfold_for_subscribers' : 'Blindfold Puzzles for Subscribers',
'support_lang_menu_title' : 'Support & Language',
'support_menu_language' : 'Language',
'language_heading_translation' : 'Translation',
'translation_production' : 'Production',
'translation_latest' : 'Latest',
'language_system' : 'System',
'universal_button_skip' : 'Skip',
'login_no_facebook_string' : 'Sorry but Facebook Login has been phased out. Please register a new email address. If you need access to your mate/tactic puzzle history, email your facebook name and new registered email to -> support@chessvis.com',
'login_button_request_password_reset' : 'Request Password Reset',
'login_title' : 'Login to Chessvis',
'login_password_reset_email_sent_line1' : 'Password Reset Email Sent',
'login_password_reset_email_sent_line2' : 'An email has been sent with a link to the chessvis website to reset your password.',
'login_password_reset_email_sent_line3' : 'Please check your spam folder if it doesn\'t show up in your inbox',
'login_unknown_email_address_line1' : 'Unknown Email address',
'login_unknown_email_address_line2' : 'The email address is not in our system.',
'login_unknown_email_address_line3' : 'Please correct or \'Register\'',
'login_no_email_address_given' : 'No Email Address given',
'login_no_password_given' : 'No Password given',
'login_email_not_in_chessvis' : 'Email Address Not In Chessvis',
'login_password_wrong' : 'Password is Incorrect',
'register_title' : 'Register for Chessvis',
'register_retype_pass' : 'Retype Pass',
'register_email_empty' : 'Email Address is empty',
'register_password_empty' : 'Password is empty',
'register_password_different' : 'Password entries are different.',
'register_sending_request' : 'Sending Register Request',
'register_already_in_line1' : 'Email Already Registered',
'register_already_in_line2' : 'The email address is already in our system.',
'register_already_in_line3' : 'Please \'Log-in\' with that email address.  If you have forgotten the password, you can request a reset email sent.',
'register_welcome' : 'Welcome to Chessvis',
'logged_off' : 'You have been logged off',
'app_name' : 'Chessvis with Openings',
'universal_button_save' : 'Save',
'universal_button_done' : 'Done',
'universal_button_start' : 'Start',
'universal_button_review' : 'Review',
'universal_report_1_error_string' : '1 Error',
'universal_button_hint' : 'Hint',
'universal_black_string' : 'Black',
'universal_white_string' : 'White',
'universal_visualize' : 'Visualize',
'universal_time_string' : 'Time',
'server_yes' : 'Yes',
'server_no' : 'No',
'server_move' : 'Move',
'server_moves' : 'Moves',
'server_piece' : 'Piece',
'server_pieces' : 'Pieces',
'server_rating' : 'Rating',
'main_menu_get_started' : 'Get Started & Videos',
'universal_opening_explorer' : 'Opening Explorer',
'main_menu_puzzles_lichess' : 'Puzzles by Lichess',
'main_menu_static_board' : 'Static Board Positions',
'universal_blindfold' : 'Blindfold',
'main_menu_subscriber' : 'Become a Subscriber',
'universal_register' : 'Register',
'universal_login' : 'Login',
'main_menu_logoff' : 'Logoff',
'main_menu_is_subscriber' : 'Subscriber until',
'main_alertdialog_whatsnew_string' : 'Chessvis has some new up-to-date information',
'universal_menu_graphs' : 'Graphs',
'universal_help' : 'Help',
'universal_options' : 'Options',
'universal_name_string' : 'Name',
'universal_email_string' : 'Email',
'universal_password_string' : 'Password',
'move_menu_random_location' : 'Moves at Random Location',
'move_menu_game_beginning' : 'Moves from Game Beginning',
'move_menu_specific_piece_options' : 'Specific Piece Options',
'move_menu_follow_specific_pieces' : 'Follow Specific Pieces',
'move_tap_for_first_move_string' : 'Tap the button for the first move',
'move_button_show_say_move' : 'Show and Say Move',
'move_button_say_move' : 'Say Move',
'move_button_show_move' : 'Show Move',
'universal_button_ready_to_update' : 'Ready to Update',
'move_random_start' : 'Random Start',
'move_at_game_start' : 'At Game Start',
'move_random_pieces' : 'Random Pieces',
'move_retrieving_sequence' : 'Retrieving Move Sequence',
'move_building_sequence' : 'Building Sequences',
'move_visualize_following_moves' : 'Visualize the following moves',
'move_update_board' : 'Update the Board to Reflect Moves Made',
'universal_check_work' : 'Check Work',
'universal_shows_answer' : 'Board Shows Your Answer',
'move_switch_to_your_answer' : 'Switch to Your Answer',
'universal_shows_actual_answer' : 'Board Shows the Actual Answer',
'move_switch_actual_answer' : 'Switch to Actual Answer',
'move_checking_move_following' : 'Checking Move Following',
'universal_nothing_attempted' : 'Nothing Attempted',
'universal_no_error' : 'No Errors',
'move_menu_title' : 'Move Following',
'move_following_options' : 'Move Following Options',
'move_following_piece_count' : 'Set the # of Chess Pieces on Board at Beginning',
'move_following_moves_in_sequence' : 'Number of Moves in Sequence',
'move_following_verbal_announce' : 'Verbally Announce the Moves?',
'move_following_show_one_move' : 'Show only one move at a time?',
'specific_piece_white_bishop' : 'White Bishop',
'specific_piece_white_knight' : 'White Knight',
'specific_piece_white_rook' : 'White Rook',
'specific_piece_white_queen' : 'White Queen',
'specific_piece_black_bishop' : 'Black Bishop',
'specific_piece_black_knight' : 'Black Knight',
'specific_piece_black_rook' : 'Black Rook',
'specific_piece_black_queen' : 'Black Queen',
'specific_piece_count_line1' : '# of Each Type of Piece',
'specific_piece_count_line2' : 'Note: need min 2 and max of 8 of each color',
'subscribe_button_onetime' : 'one-time',
'universal_perpetual' : 'Perpetual',
'blindfold_reveal_popup' : 'Ready to reveal board after engine\'s move',
'ios_blindfold_reveal_title' : 'Ready to Reveal',
'ios_subscription_store_problem' : 'The three subscriptions aren\'t in the store. Please try again later. If the problem persists, please contact -- support@chessvis.com',
'ios_subscribe_text_v7' : 'Chessvis subscriptions unlock Repertoires, Advanced Puzzles, Analyze My Games and more',
'repertoire_menu_title' : 'Opening Repertoires',
'opening_not_subscriber_message' : '\'Repertoires\' is reserved for Subscribers.',
'download_my_games' : 'Download My Games',
'explore_my_games' : 'Explore My Games',
'explore_top_games' : 'Explore Top Players',
'download_process_beginning' : 'processing from beginning',
'download_process_to' : 'processed to',
'download_through' : 'downloaded through',
'lichess_download_speed' : 'Download speed is 600 games per 20 seconds',
'click_download' : 'Click \'Download\' to process',
'download_yet' : 'games downloaded yet',
'busy_downloading' : 'Busy Downloading',
'enter_usernames' : 'Enter Your User Names for',
'universal_lichess' : 'Lichess',
'universal_chesscom' : 'Chess.com',
'universal_download' : 'Download',
'universal_downloading' : 'Downloading',
'universal_check' : 'Check',
'universal_checking' : 'Checking',
'username_changed' : 'username changed',
'username_set' : 'username set',
'lichess_unknown_user' : 'Lichess says unknown user',
'chesscom_unknown_user' : 'Chess.com reports',
'my_games_filter_heading' : 'My Game Filter',
'my_games_source' : 'Source',
'my_games_time_period' : 'Time Period',
'my_games_rated' : 'Rated and/or Not',
'universal_rated' : 'Rated',
'universal_casual' : 'Casual',
'my_games_classical' : 'Classical',
'my_games_24_hours' : '24 hours',
'my_games_7_days' : '7 days',
'my_games_31_days' : '31 days',
'my_games_6_months' : '6 months',
'user_game_filter_button' : 'Filter',
'user_games_download_first' : 'Please download your games first',
'top_player_title' : 'Top Players',
'top_players_loading_names' : 'Loading Names',
'visualize_menu_title' : 'Visualization Tools',
'follow_game_moves' : 'Follow Game Moves',
'mygame_menu_title' : 'Analyze My Games',
'mygame_not_subscriber_message' : '\'My Games\' is reserved for Subscribers.',
'blindfold_not_subscriber_message' : 'Unlimited blindfold options and puzzles are reserved for Subscribers.',
'blind_easy_play' : 'Easy Blindfold Chess',
'repertoire_library_button_contribute' : 'Have a repertoire to contribute?',
'repertoire_library_button_contribute_one_word' : 'Contribute?',
'report_menu_how_everyone_doing' : 'How\'s Everyone Else Doing?',
'server_graph_success_everyone' : 'Everyone\'s Success',
'server_graph_success_compare' : 'How Am I Doing?',
'server_graph_success_my' : 'My Success',
'universal_button_flip_board' : 'Flip',
'universal_button_viewer' : 'Viewer',
'universal_button_viewer_short' : 'View',
'universal_button_games' : 'Games',
'universal_button_reveal' : 'Reveal',
'universal_button_builder' : 'Builder',
'universal_button_builder_short' : 'Build',
'universal_button_repertoire' : 'Repertoire',
'universal_button_copy' : 'Copy',
'universal_button_edit' : 'Edit',
'universal_button_add' : 'Add',
'universal_button_delete' : 'Delete',
'universal_button_delete_short' : 'Del',
'universal_button_cancel' : 'Cancel',
'opening_menu_title' : 'Openings',
'opening_menu_play' : 'Play Against Game Collection',
'opening_menu_builder' : 'Repertoire Builder',
'opening_menu_viewer' : 'Repertoire Tree Viewer',
'opening_menu_practice' : 'Repertoire Practice',
'opening_menu_import' : 'Import Repertoires by Email',
'opening_game_group_collections' : 'Game Collections',
'opening_game_group_master' : 'Master Games',
'opening_game_group_lichess' : 'Lichess Games',
'opening_game_group_lichess2' : 'Type & Rating intersect',
'opening_game_master_filters' : 'Apply Master Filters',
'opening_game_lichess_filters' : 'Apply Lichess Filters',
'opening_game_master_no_rating' : 'No Known Rating',
'opening_game_master_below_2000' : 'Below Elo 2000',
'opening_game_master_to_2200' : 'Elo 2000 to 2200',
'opening_game_master_to_2400' : 'Elo 2200 to 2400',
'opening_game_master_to_2600' : 'Elo 2400 to 2600',
'opening_game_master_over_2600' : 'Over Elo 2600',
'opening_game_lichess_group_game_type' : 'Game Type',
'opening_game_lichess_group_rating_bracket' : 'Rating Bracket',
'opening_game_lichess_bullet' : 'Bullet',
'opening_game_lichess_blitz' : 'Blitz',
'opening_game_lichess_rapid' : 'Rapid',
'opening_game_lichess_correspondence' : 'Correspondence',
'opening_game_lichess_below_20' : 'Below 20th Percentile',
'opening_game_lichess_to_40' : '20th to 40th Percentile',
'opening_game_lichess_to_60' : '40th to 60th Percentile',
'opening_game_lichess_to_80' : '60th to 80th Percentile',
'opening_game_lichess_to_95' : '80th to 95th Percentile',
'opening_game_lichess_to_99' : '95th to 99th Percentile',
'opening_game_lichess_top_1' : 'Top 1%',
'opening_barchart_edge_won' : 'Won',
'opening_explorer_move_not_in_collection' : 'Not In Collection',
'opening_repertoire_heading_white' : 'Playing White',
'opening_repertoire_heading_black' : 'Playing Black',
'opening_repertoire_heading_import' : 'Imported - Must Assign Color Before Use',
'opening_repertoire_library_white' : 'Library - Playing White',
'opening_repertoire_library_black' : 'Library - Playing Black',
'repertoire_library_title' : 'Repertoire Library',
'new_repertoire_add_hint' : 'New Repertoire Name',
'add_rep_button_text' : 'Add New Repertoire',
'game_filter_heading' : 'Define Game Collection',
'repertoire_label' : 'Using Repertoire',
'future_barchart_not_enough_data_string' : 'Not Enough # of Games',
'opening_import_instruction_string' : 'Your unique email address to send PGN files containing repertoires',
'opening_import_subject_string' : 'start SUBJECT line with 3 letters: Rep',
'opening_import_below_subject_string' : 'Emails without Rep will be ignored',
'opening_import_history_title' : 'Import History',
'opening_import_button_set_username' : 'Set User Name',
'opening_import_button_refresh_download' : 'Refresh Download',
'opening_import_title' : 'Import by Email',
'opening_practice_button_again' : 'Again',
'opening_practice_button_next' : 'Next',
'opening_practice_end_of_line' : 'End of Line',
'opening_practice_that_line_done' : 'Practice Lines involving',
'opening_practice_that_line_done_select_another' : 'have already been done. Select another move.',
'opening_no_repertoire_selected' : 'No Repertoire Selected',
'opening_repertoire_not_assigned_color' : 'has NOT been assigned a \'playing as\' color. Tap the \'Repertoire\' button and then \'Edit\'',
'opening_button_comment' : 'Comment',
'opening_button_comment_very_short' : 'Com',
'opening_button_repertoire_short' : 'Rep',
'opening_button_game_filter_short' : 'Game',
'opening_import_button_set_name_short' : 'Set Name',
'opening_import_button_refresh_short' : 'Refresh',
'opening_just_play_string_line1' : 'Just Play &',
'opening_just_play_string_line2' : 'Opponent Moves will come from game collection - weighted by popularity',
'opening_just_play_no_more_moves' : '(no more moves)',
'opening_practice_no_moves_in_repertoire' : 'Repertoire doesn\'t have any moves or there isn\'t an active repertoire',
'opening_reptree_no_working_repertoire' : 'No working repertoire has been assigned. Please use the Repertoire Manager to create one',
'opening_reptree_no_color_assigned' : 'needs to be assigned a color by the Repertoire Manager before the tree can be displayed',
'repertoire_edit_title' : 'Edit Repertoire Info',
'repertoire_library_contribute' : 'Have a repertoire to contribute? Use \'Contact\' screen to send message',
'repertoire_manager_practice' : 'Select for Practice',
'repertoire_manager_builder' : 'Select for Builder',
'repertoire_manager_viewer' : 'Select for Viewer',
'repertoire_manager_import' : 'Imported Repertoires',
'repertoire_manager_title' : 'Repertoire Manager',
'opening_import_download_email' : 'Download email name set',
'opening_import_name_taken' : 'New name is already taken',
'opening_import_name_didnt_change' : 'Name didn\'t change',
'opening_repertoire_change_error' : 'Repertoire Change could not be done because ->',
'opening_repertoire_name_blank' : 'Repertoire Name is Blank',
'opening_repertoire_pick_color' : 'Repertoire must be for either White or Black',
'opening_repertoire_library_copy_error' : 'A problem occurred copying the library repertoire',
'opening_repertoire_copied' : 'The repertoire has been copied to ->',
'opening_repertoire_contact_soon' : 'Thanks. Chessvis support will be in contact soon.',
'opening_import_email_invalid' : 'The email address is invalid. Can be only alpha,numeric,dot,underscore',
'opening_import_reportoires_string' : 'Repertoires',
'server_lines_done' : 'lines done',
'server_of_lines_done' : 'of',
'repertoire_edit_description_label' : 'Description',
'repertoire_edit_play_as_string' : 'Play as',
'opening_practice_which_color' : '"Practice Playing White"',
'server_merged' : 'Merged',
'universal_button_explore' : 'Explore',
'universal_button_review_short' : 'Rev',
'universal_button_explore_very_short' : 'Exp',
'universal_button_explore_short' : 'Xplr',
'universal_category_string' : 'Category',
'universal_puzzle_options' : 'Puzzle Options',
'server_your_current_rating' : 'Your Current Rating',
'universal_play_black' : 'Play Black',
'universal_play_white' : 'Play White',
'puzzle_menu_subscriber_heading' : 'Subscribers',
'puzzle_menu_solveit' : 'Regular',
'universal_button_timed' : 'Timed',
'puzzle_menu_offline_solveit' : 'Off-line Solve It!',
'puzzle_menu_offline_sync' : 'Off-line Sync',
'puzzle_menu_history' : 'History',
'puzzle_menu_export' : 'Export',
'puzzle_menu_sync_with_counts' : 'Puzzle Sync',
'puzzle_options_visualize' : '# of Moves to Visualize',
'universal_button_speed' : 'Speed',
'mate_tap_start' : 'Tap Start',
'mate_get_next' : 'Get Next',
'mate_problem_abandoned' : 'Problem Abandoned',
'mate_give_up' : 'Give Up',
'mate_retrieving' : 'Retrieving',
'mate_tap_from_square_string' : 'Tap \'From Square\'',
'mate_visualize_your_moves' : 'Your Moves',
'mate_move_from_string' : 'Move From',
'mate_move_to_string' : 'to',
'mate_move_invalid_string' : 'Invalid',
'mate_visualize_hint' : 'Hint ->',
'mate_enter_move' : 'Enter Move',
'mate_visualize_right_arrow' : '> for visualized moves',
'mate_solution_revealed' : 'Solution Revealed',
'mate_get_computer_move' : 'Getting computer move',
'mate_updating_score' : 'Updating score',
'mate_getting_initial_score' : 'Getting initial score',
'mate_getting_hint' : 'Getting hint',
'mate_title_solveit' : 'Solve-It!',
'mate_title_offline_solveit' : 'Offline Solve-It!',
'mate_blindfold_on_string' : 'Tap HERE for your Blindfold',
'mate_possible_passant' : 'Possible Passant',
'mate_out_of_time_string' : 'Out of Time',
'mate_you_short_string' : 'You',
'mate_history_title' : 'Puzzle History',
'server_visualize_half_move' : '1 Opponent Move (1 Half Move)',
'server_visualize_move' : 'Full Move',
'server_visualize_moves' : 'Full Moves',
'server_history_half_move' : 'Visualize half move',
'server_history_one_move' : 'Visualize 1 move',
'server_puzzle_seconds' : 'Seconds',
'server_puzzle_stay_within_rating' : 'Stay within',
'puzzle_offline_sync_dialog' : 'Please do a \'Puzzle Sync\' to load the off-line puzzle inventory. Note: this needs an internet connection.',
'puzzle_offline_sync_progress_dialog' : 'Syncing Puzzle Attempts and Refreshing Off-line Puzzle Inventory',
'puzzle_subscriber_history_dialog' : 'Puzzle history and export are reserved for Chessvis subscribers.',
'puzzle_subscriber_timed_dialog' : 'Timed puzzles to sharpen pattern recognition are reserved for Chessvis subscribers.',
'puzzle_subscriber_offline_dialog' : 'Off-line puzzles which enable you to practice when you don\'t have an internet connection are reserved for Chessvis subscribers.',
'server_checkmate' : 'Checkmate',
'server_stalemate' : 'Stalemate',
'server_draw' : 'Draw',
'server_mate_in_1' : 'Mate in 1',
'server_mate_in' : 'mate in',
'server_other' : 'Other',
'server_unknown' : 'unknown response from engine',
'server_by' : 'by',
'piece_chars' : 'R,N,B,Q,K',
'file_chars' : 'a,b,c,d,e,f,g,h',
'capture_char' : 'x',
'million_thousand_chars' : 'M,K',
'puzzle_timed_options' : 'Timed Options',
'puzzle_timed_solveit' : 'Timed Solve It!',
'puzzle_timed_visualize' : 'Timed Visualize',
'timed_puzzle_options' : 'Timed Puzzle Options',
'puzzle_cat_all' : 'All',
'puzzle_cat_all_long' : 'Includes every puzzle',
'puzzle_cat_onemove' : '1 move puzzle',
'puzzle_cat_onemove_long' : 'A puzzle that is only one move long.',
'puzzle_cat_onemove_barchart' : '1 move',
'puzzle_cat_twomove' : '2 move puzzle',
'puzzle_cat_twomove_long' : 'Two moves to win.',
'puzzle_cat_twomove_barchart' : '2 move',
'puzzle_cat_threemove' : '3 move puzzle',
'puzzle_cat_threemove_long' : 'Three moves to win.',
'puzzle_cat_threemove_barchart' : '3 move',
'puzzle_cat_verylong' : '4+ move puzzle',
'puzzle_cat_verylong_long' : 'Four moves or more to win.',
'puzzle_cat_verylong_barchart' : '4+ move',
'puzzle_cat_matein1' : '1 move mate',
'puzzle_cat_matein1_long' : 'Checkmate in 1 move',
'puzzle_cat_matein2' : '2 move mate',
'puzzle_cat_matein2_long' : 'Checkmate in 2 moves',
'puzzle_cat_matein2_barchart' : 'Mate in 2',
'puzzle_cat_matein3' : '3 move mate',
'puzzle_cat_matein3_long' : 'Checkmate in 3 moves',
'puzzle_cat_matein3_barchart' : 'Mate in 3',
'puzzle_cat_matein4' : '4 move mate',
'puzzle_cat_matein4_long' : 'Checkmate in 4 moves',
'puzzle_cat_matein4_barchart' : 'Mate in 4',
'puzzle_cat_matein5' : '5+ move mate',
'puzzle_cat_matein5_long' : 'Checkmate in 5 or more move',
'puzzle_cat_matein5_barchart' : 'Mate in 5+',
'puzzle_cat_advancedpawn' : 'Advanced pawn',
'puzzle_cat_advancedpawn_long' : 'One of your pawns is deep into the opponent position, maybe threatening to promote.',
'puzzle_cat_attackingf2f7' : 'Attacking f2 or f7',
'puzzle_cat_attackingf2f7_long' : 'An attack focusing on the f2 or f7 pawn, such as in the fried liver opening.',
'puzzle_cat_attackingf2f7_barchart' : 'Attack f2/f7',
'puzzle_cat_capturingdefender' : 'Capture the defender',
'puzzle_cat_capturingdefender_long' : 'Removing a piece that is critical to defence of another piece, allowing the now undefended piece to be captured on a following move.',
'puzzle_cat_capturingdefender_barchart' : 'Capture defender',
'puzzle_cat_discoveredattack' : 'Discovered attack',
'puzzle_cat_discoveredattack_long' : 'Moving a piece that previously blocked an attack by another long range piece, such as a knight out of the way of a rook.',
'puzzle_cat_doublecheck' : 'Double check',
'puzzle_cat_doublecheck_long' : 'Checking with two pieces at once, as a result of a discovered attack where both the moving piece and the unveiled piece attack the opponent\'s king.',
'puzzle_cat_exposedking' : 'Exposed king',
'puzzle_cat_exposedking_long' : 'A tactic involving a king with few defenders around it, often leading to checkmate.',
'puzzle_cat_fork' : 'Fork',
'puzzle_cat_fork_long' : 'A move where the moved piece attacks two opponent pieces at once.',
'puzzle_cat_hangingpiece' : 'Hanging piece',
'puzzle_cat_hangingpiece_long' : 'A tactic involving an opponent piece being undefended or insufficiently defended and free to capture.',
'puzzle_cat_kingsideattack' : 'Kingside attack',
'puzzle_cat_kingsideattack_long' : 'An attack on the opponent\'s king, after they castled on the king side.',
'puzzle_cat_pin' : 'Pin',
'puzzle_cat_pin_long' : 'A tactic involving pins, where a piece is unable to move without revealing an attack on a higher value piece.',
'puzzle_cat_queensideattack' : 'Queenside attack',
'puzzle_cat_queensideattack_long' : 'An attack on the opponent\'s king, after they castled on the queen side.',
'puzzle_cat_sacrifice' : 'Sacrifice',
'puzzle_cat_sacrifice_long' : 'A tactic involving giving up material in the short-term, to gain an advantage again after a forced sequence of moves.',
'puzzle_cat_skewer' : 'Skewer',
'puzzle_cat_skewer_long' : 'A motif involving a high value piece being attacked, moving out the way, and allowing a lower value piece behind it to be captured or attacked, the inverse of a pin.',
'puzzle_cat_trappedpiece' : 'Trapped piece',
'puzzle_cat_trappedpiece_long' : 'A piece is unable to escape capture as it has limited moves.',
'puzzle_cat_opening' : 'Opening',
'puzzle_cat_opening_long' : 'A tactic during the first phase of the game.',
'puzzle_cat_middlegame' : 'Middlegame',
'puzzle_cat_middlegame_long' : 'A tactic during the second phase of the game.',
'puzzle_cat_endgame' : 'Endgame',
'puzzle_cat_endgame_long' : 'A tactic during the last phase of the game.',
'puzzle_cat_rookendgame' : 'Rook endgame',
'puzzle_cat_rookendgame_long' : 'An endgame with only rooks and pawns.',
'puzzle_cat_bishopendgame' : 'Bishop endgame',
'puzzle_cat_bishopendgame_long' : 'An endgame with only bishops and pawns.',
'puzzle_cat_pawnendgame' : 'Pawn endgame',
'puzzle_cat_pawnendgame_long' : 'An endgame with only pawns.',
'puzzle_cat_knightendgame' : 'Knight endgame',
'puzzle_cat_knightendgame_long' : 'An endgame with only knights and pawns.',
'puzzle_cat_queenendgame' : 'Queen endgame',
'puzzle_cat_queenendgame_long' : 'An endgame with only queens and pawns.',
'puzzle_cat_queenrookendgame' : 'Queen and Rook',
'puzzle_cat_queenrookendgame_long' : 'An endgame with only queens, rooks and pawns.',
'puzzle_cat_queenrookendgame_barchart' : 'Queen & Rook',
'puzzle_cat_attraction' : 'Attraction',
'puzzle_cat_attraction_long' : 'An exchange or sacrifice encouraging or forcing an opponent piece to a square that allows a follow-up tactic.',
'puzzle_cat_clearance' : 'Clearance',
'puzzle_cat_clearance_long' : 'A move, often with tempo, that clears a square, file or diagonal for a follow-up tactical idea.',
'puzzle_cat_defensivemove' : 'Defensive move',
'puzzle_cat_defensivemove_long' : 'A precise move or sequence of moves that is needed to avoid losing material or another advantage.',
'puzzle_cat_deflection' : 'Deflection',
'puzzle_cat_deflection_long' : 'A move that distracts an opponent piece from another duty that it performs, such as guarding a key square. Sometimes also called "overloading".',
'puzzle_cat_interference' : 'Interference',
'puzzle_cat_interference_long' : 'Moving a piece between two opponent pieces to leave one or both opponent pieces undefended, such as a knight on a defended square between two rooks.',
'puzzle_cat_intermezzo' : 'Intermezzo',
'puzzle_cat_intermezzo_long' : 'Instead of playing the expected move, first interpose another move posing an immediate threat that the opponent must answer. Also known as "Zwischenzug" or "In between".',
'puzzle_cat_quietmove' : 'Quiet move',
'puzzle_cat_quietmove_long' : 'A move that does not make a check or capture, but does prepare an unavoidable threat for a later move.',
'puzzle_cat_xrayattack' : 'X-Ray attack',
'puzzle_cat_xrayattack_long' : 'A piece attacks or defends a square, through an enemy piece.',
'puzzle_cat_zugzwang' : 'Zugzwang',
'puzzle_cat_zugzwang_long' : 'The opponent is limited in the moves they can make, and all moves worsen their position.',
'puzzle_cat_anastasiamate' : 'Anastasia\'s mate',
'puzzle_cat_anastasiamate_long' : 'A knight and rook or queen team up to trap the opposing king between the side of the board and a friendly piece.',
'puzzle_cat_arabianmate' : 'Arabian mate',
'puzzle_cat_arabianmate_long' : 'A knight and a rook team up to trap the opposing king on a corner of the board.',
'puzzle_cat_backrankmate' : 'Back rank mate',
'puzzle_cat_backrankmate_long' : 'Checkmate the king on the home rank, when it is trapped there by its own pieces.',
'puzzle_cat_bodenmate' : 'Boden\'s mate',
'puzzle_cat_bodenmate_long' : 'Two attacking bishops on criss-crossing diagonals deliver mate to a king obstructed by friendly pieces.',
'puzzle_cat_doublebishopmate' : 'Double bishop mate',
'puzzle_cat_doublebishopmate_long' : 'Two attacking bishops on adjacent diagonals deliver mate to a king obstructed by friendly pieces.',
'puzzle_cat_doublebishopmate_barchart' : 'Two bishop mate',
'puzzle_cat_dovetailmate' : 'Dovetail mate',
'puzzle_cat_dovetailmate_long' : 'A queen delivers mate to an adjacent king, whose only two escape squares are obstructed by friendly pieces.',
'puzzle_cat_hookmate' : 'Hook mate',
'puzzle_cat_hookmate_long' : 'Checkmate with a rook, knight, and pawn along with one enemy pawn to limit the enemy king\'s escape.',
'puzzle_cat_smotheredmate' : 'Smothered mate',
'puzzle_cat_smotheredmate_long' : 'A checkmate delivered by a knight in which the mated king is unable to move because it is surrounded (or smothered) by its own pieces.',
'puzzle_cat_castling' : 'Castling',
'puzzle_cat_castling_long' : 'Bring the king to safety, and deploy the rook for attack.',
'puzzle_cat_enpassant' : 'En Passant',
'puzzle_cat_enpassant_long' : 'A tactic involving the en passant rule, where a pawn can capture an opponent pawn that has bypassed it using its initial two-square move.',
'puzzle_cat_promotion' : 'Promotion',
'puzzle_cat_promotion_long' : 'Promote one of your pawns to a queen or minor piece.',
'puzzle_cat_underpromotion' : 'Underpromotion',
'puzzle_cat_underpromotion_long' : 'Promotion to a knight, bishop, or rook.',
'puzzle_cat_equality' : 'Equality',
'puzzle_cat_equality_long' : 'Come back from a losing position, and secure a draw or a balanced position. (eval ? 200cp)',
'puzzle_cat_advantage' : 'Advantage',
'puzzle_cat_advantage_long' : 'Seize your chance to get a decisive advantage. (200cp ? eval ? 600cp)',
'puzzle_cat_crushing' : 'Crushing',
'puzzle_cat_crushing_long' : 'Spot the opponent blunder to obtain a crushing advantage. (eval ? 600cp)',
'puzzle_cat_mate' : 'Mate',
'puzzle_cat_mate_long' : 'All checkmate puzzles combined',
'puzzle_cat_master' : 'Master games',
'puzzle_cat_master_long' : 'Puzzles from games played by titled players.',
'puzzle_cat_mastervsmaster' : 'Master vs Master games',
'puzzle_cat_mastervsmaster_long' : 'Puzzles from games between two titled players.',
'puzzle_cat_mastervsmaster_barchart' : 'Master / Master',
'puzzle_cat_supergm' : 'Super GM games',
'puzzle_cat_supergm_long' : 'Puzzles from games played by the best players in the world.',
'puzzle_cat_supergm_barchart' : 'Super GM',
'puzzle_cat_do_over' : 'Do over',
'puzzle_cat_do_over_long' : 'Puzzles you tried again.',
'puzzle_cat_newbies' : 'New puzzles',
'puzzle_cat_newbies_long' : 'New or unpopular puzzles.',
'support_menu_title' : 'About & Support',
'support_show_english' : 'Show English',
'support_show_translation' : 'Show Translation',
'support_show_debug_translation' : 'Debug Translation (for translators)',
'support_stop_debug_translation' : 'Stop Debug Translation',
'static_menu_visualize' : 'Visualize a Static Board',
'static_board_title' : 'Static Boards',
'static_retrieving_board' : 'Retrieving Board',
'static_checking_board' : 'Checking Board',
'static_visualize_board' : 'Visualize the Board',
'static_replicate_board' : 'Replicate the Board',
'server_static_eighth' : 'Eighth',
'server_static_quarter' : 'Quarter',
'server_static_half' : 'Half',
'server_static_full' : 'Full',
'static_options_title' : 'Static Board Options',
'static_options_pieces' : 'Set the # of Chess Pieces to Visualize',
'static_options_area' : 'Amount of the Board Pieces are Spread Across',
'subscribe_title' : 'Loading Subscriber Information',
'subscribe_button_join_at' : 'Join at',
'subscribe_button_year' : 'year',
'subscribe_button_month' : 'month',
'thank_you_subscriber' : 'Thank you for becoming a subscriber!',
'subscribers_not_dummy_user' : 'Subscribers must be logged in',
'support_menu_introduction' : 'Introduction',
'support_menu_contact' : 'Contact',
'support_menu_whatsnew' : 'What\'s New',
'support_menu_terms' : 'Terms of Service',
'contact_title_line1' : 'Contact By this Form',
'contact_title_line2' : '(Or email support@chessvis.com)',
'contact_message_string' : 'Message',
'contact_button_send' : 'Send',
'contact_name_is_empty' : 'Name is Empty',
'contact_email_is_empty' : 'Email is Empty',
'contact_message_is_empty' : 'Message is Empty',
'contact_acknowledge_information_sent' : 'Contact Information Sent.  Thank you.',
'myaccount_heading' : 'My Account',
'board_coordinates' : 'Board Coordinates',
'server_inside' : 'Inside',
'server_outside' : 'Outside',
'server_none' : 'None',
'preference_not_subscriber_message' : 'Account preferences are reserved for subscribers',
'puzzle_count_target' : 'Daily Puzzle Target',
'video_menu_title' : 'Help & Videos',
'video_menu_getting_started' : 'Getting Started',
'video_menu_videos' : 'Videos',
'help_loading_string' : 'Loading Help',
'help_whatsnew_title' : 'What\'s New with Chessvis',
'video_visualize' : 'Puzzle Visualization',
'video_repertoire_builder' : 'Repertoire - Build & View',
'video_repertoire_practice' : 'Repertoire - Practice',
'video_repertoire_import' : 'Import Repertoires'

  }),
  getters: {
    getStrings() {
      return (this)
    }
  },
  actions: {
    getStringByName(key) {
      const value = this[key]
      if (value !== undefined)
        return value
      return key
    },
    expandServerString(fromServer) {
      var isKey = false
      var newExploded = []
      
      //console.log("expand  ",fromServer)
      if (fromServer === undefined || fromServer == "")
        return ""
      
      const explodedString = fromServer.split("~")
      //console.log("exploded ",explodedString)
      if (explodedString.length <= 1)
        return fromServer
      
      // the odd numbered array elements are the keywords.  blah ~server_xyz~ abc ~server_mno~ end bit

      for (var i=0; i < explodedString.length; i++) {
        if (isKey == false)
          newExploded.push(explodedString[i])
        else {
          const value = this.getStringByName(explodedString[i])
          newExploded.push(value)
        }
        isKey = !isKey
      }
      
      const combined = newExploded.join("")
      return (combined);
  }
  }

})